import { Weddings } from '@bridebook/models';
import type { IWedding_RSVP } from '@bridebook/models/source/models/Weddings.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateWeddingRsvpCache } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import { useSelector } from '@bridebook/web/lib/utils';
import { getWeddingId } from '@bridebook/web/lib/weddings/selectors';

export const useCreateWeddingRsvp = () => {
  const queryClient = useQueryClient();
  const weddingId = useSelector(getWeddingId);
  const mutation = useMutation({
    mutationFn: async (rsvp: IWedding_RSVP) => {
      await Weddings._.getById(weddingId).set({ rsvp }, true);
      return rsvp;
    },
    onSettled: (data) => {
      if (data) {
        updateWeddingRsvpCache(queryClient, weddingId, data);
      }
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};
